import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private router: Router,
    private tokenStorage: TokenStorageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Check if user is logged in using TokenStorageService
    if (this.tokenStorage.isLoggedIn()) {
      // Check if session is expired
      if (this.tokenStorage.isSessionExpired()) {
        // Session expired, clear and redirect
        this.tokenStorage.signOut();
        this.router.navigate(['/auth/signin/cover'], {
          queryParams: { returnUrl: state.url, expired: 'true' }
        });
        return false;
      }

      // Update last activity
      this.tokenStorage.updateLastActivity();
      return true;
    }

    // Not logged in, redirect to login
    this.router.navigate(['/auth/signin/cover'], {
      queryParams: { returnUrl: state.url }
    });
    return false;
  }
}
